import { styled } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons/faExclamationTriangle";

const WarningWrapper = styled("div")`
  margin-top: 0.75rem;
  color: ${({ theme }) => theme.palette.warning.main};
  font-size: 0.75rem;

  & > svg {
    font-size: 75%;
    vertical-align: 0;
    margin-right: 0.5rem;
  }

  & + & {
    margin-top: 0.25rem;
  }
`;

export const EmailTypoWarning = () => (
  <WarningWrapper data-testid="email-misspelled-warning">
    <FontAwesomeIcon icon={faExclamationTriangle} />
    Your email address might be misspelled. No changes are needed if it&apos;s correct.
  </WarningWrapper>
);
